import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import ScrollWordsLayering from '@/components/ScrollWordsLayering';
import ScrollOpacity from '@/components/ScrollOpacity';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/ces/pc/');

export default function SectionL() {
    const { useLang } = useGlobal();
    const { t } = useLang('ces2023.sectionH');

    return (
        <div className={styles.sectionL}>
            <div className="viewport-wrapper">
                <div className="title">
                    <ScrollOpacity scrollRatio={5} leaveAdvanceRatio={2}>
                        <ScrollWordsLayering lines={1} scrollRatio={3}>
                            {t('title')}
                        </ScrollWordsLayering>
                    </ScrollOpacity>
                </div>
                <div className="desc">
                    <ScrollOpacity scrollRatio={5} leaveAdvanceRatio={2}>
                        <ScrollWordsLayering lines={2} scrollRatio={3}>
                            {t('desc')}
                        </ScrollWordsLayering>
                    </ScrollOpacity>
                </div>
                <EFPic className="img" name={['07.webp', '07.jpg']} />
            </div>
        </div>
    );
}
